import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import { connect } from "react-redux";
import { deleteSize, updateSize } from "./CRMProductAction";
import { baseURL, headers } from "../../../../../global/api";
import { setHeading } from "../../../accounts/account.actions";
import MaterialSize from "material-table";


const ViewProductCRM = (props) => {

  useEffect(() => {
    props.setHeading("Service List");
  }, []);

  return (
    <>
      <Container fluid>
        <MaterialSize
          title="Service Details"
          columns={[
            { title: "Service Name", field: "productName" },
            { title: 'Service Description', field: 'productDescription' },
          ]}
          data={(query) =>
            new Promise((resolve, reject) => {
              let url = `${baseURL}/CRMProduct?`;
              url += "limit=" + query.pageSize;
              url += "&page=" + (query.page);
              url += "&search=" + query.search;
              fetch(url, {
                method: "GET",
                headers: headers,
              }).then((response) => response.json()).then((result) => {
                resolve({
                  data: result.data,
                  page: result.page,
                  totalCount: result.total_results,
                });
              });
            })
          }
          options={{
            actionsColumnIndex: -1,
            exportButton: true,
            exportAllData: true,
            paging: true,
            pageSize: 50,
            emptyRowsWhenPaging: false,
            pageSizeOptions: [50, 100, 150, 200],
            headerStyle: {
              position: "sticky",
              top: 0,
              color: "#00BBBB",
              fontWeight: "550",
              onRowAdd: "none",
            },
          }}
          editable={{
            onRowUpdate: (newData, oldData) =>
              new Promise((resolve) => {
                setTimeout(() => {
                  resolve();
                  props.updateSize(newData, oldData);
                }, 600);
              }),
            onRowDelete: (oldData) =>
              new Promise((resolve) => {
                setTimeout(() => {
                  resolve();
                  props.deleteSize(oldData._id);
                }, 600);
              }),
          }}
        />
      </Container>
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    deleteSize: (tableId) => dispatch(deleteSize(tableId)),
    updateSize: (newData, oldData) => dispatch(updateSize(newData, oldData)),
    setHeading: (data) => dispatch(setHeading(data)),
  };
};
const mapStateToProps = (state, ownProps) => ({
  isFetchingCRMProduct: state.CRMProductReducer.isFetchingCRMProduct,
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewProductCRM);